import * as yup from 'yup';
import { OTHERS_CATEGORY } from '../CustomsInvoiceItemTypes.js';

const hasMoreThanTwoDecimals = value => {
  const regEx = new RegExp(/[,.'](\d{3,})/);
  return value ? !regEx.test(value.toString()) : false;
};
const getInventoryItemValidation = t => {
  const tariffNumberLabel = {
    field: t('inventory-item.label.tariff-number')
  };
  const numberOfItemsLabel = {
    field: t('inventory-item.label.number-of-items')
  };
  const valueLabel = {
    field: t('inventory-item.label.value')
  };
  const weightLabel = {
    field: t('inventory-item.label.weight')
  };
  return yup.object().shape({
    description: yup.string().trim().required(t('form.error.required', {
      field: t('inventory-item.label.description')
    })),
    category: yup.object().required(t('form.error.required', {
      field: t('inventory-item.label.select-category')
    })),
    tariffNumber: yup.mixed().when('category', {
      is: category => (category === null || category === void 0 ? void 0 : category.value) === OTHERS_CATEGORY,
      then: yup.number().required(t('form.error.required', tariffNumberLabel)).integer(t('form.error.decimals-disallowed', tariffNumberLabel)).positive(t('form.error.positive', tariffNumberLabel)).test('min-characters', t('form.error.min', {
        ...tariffNumberLabel,
        number: 6
      }), value => {
        var _value$toString$lengt;
        return ((_value$toString$lengt = value === null || value === void 0 ? void 0 : value.toString().length) !== null && _value$toString$lengt !== void 0 ? _value$toString$lengt : 0) > 5;
      }).test('max-characters', t('form.error.max', {
        ...tariffNumberLabel,
        number: 8
      }), value => {
        var _value$toString$lengt2;
        return ((_value$toString$lengt2 = value === null || value === void 0 ? void 0 : value.toString().length) !== null && _value$toString$lengt2 !== void 0 ? _value$toString$lengt2 : 0) < 9;
      })
    }),
    countryOfOrigin: yup.object().required(t('form.error.required', {
      field: t('inventory-item.label.country-of-origin')
    })),
    numberOfItems: yup.number().typeError(t('form.error.required', numberOfItemsLabel)).integer(t('form.error.decimals-disallowed', numberOfItemsLabel)).positive(t('form.error.positive', numberOfItemsLabel)).required(t('form.error.required', numberOfItemsLabel)),
    value: yup.number().typeError(t('form.error.required', valueLabel)).required(t('form.error.required', valueLabel)).positive(t('form.error.positive', valueLabel)).test('decimals-limit', t('form.error.decimals-limit', {
      ...valueLabel,
      limit: 2
    }), value => hasMoreThanTwoDecimals(value)),
    weight: yup.number().nullable().typeError(t('form.error.required', weightLabel)).required(t('form.error.required', weightLabel)).positive(t('form.error.positive', weightLabel)).test('decimals-limit', t('form.error.decimals-limit', {
      ...weightLabel,
      limit: 2
    }), value => hasMoreThanTwoDecimals(value))
  }).defined();
};

export { getInventoryItemValidation };
//# sourceMappingURL=inventoryItemValidation.js.map
